// extracted by mini-css-extract-plugin
export default {"defaultFont":"App_defaultFont__W88aR"};